import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalInfo } from "../../Contexts/GlobalContext";
import TokenService from "../../Services/Token.service";
import { SampleRequestService } from "../../Services/SampleRequest.Service";
import DashboardCards from "../../Components/Dashboard/DashboardCards";
import SampleRequests from "../Admin/SampleRequests/SampleRequests";
import Toaster from "../../Components/Toaster";

import DonationLogo from '../../Assets/images/donation.svg';
import TodaysDonationLogo from '../../Assets/images/today-donation.svg';
import { useLocation, useNavigate } from "react-router-dom";
function RequestorHome() {
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [openRequests, setOpenRequests] = useState();
    const [appointments, setAppointments] = useState();

    const [selectedRange, setSelectedRange] = useState('30 days');
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => { 
        if (location.state?.toastMessage) {
                setShowToast(true);
                setToastMessage(location.state.toastMessage);
                setToastVariant(location.state.toastVariant);
            // showToast(location.state.toastMessage, location.state.toastVariant);
             // Clear location.state to prevent the toast from triggering on refresh
             navigate(location.pathname, { replace: true }); 
        }
    },[], [location.state, showToast, navigate]);
    useEffect(() => {
        const userId = TokenService.getUserId();
        const params = {
            flag: 0, 
            range: selectedRange,
            user_id: userId,
           
        };

        SampleRequestService.getTotalWidgetCount(params)
            .then((response) => {
                if (response.success) {                    
                    if (response.count) {
                        setOpenRequests(response.count.open_request);
                        setAppointments(response.count.appointment);
                    }
                } else {
                    setShowToast(true);
                    setToastMessage(response.message);
                    setToastVariant("danger");
                }
            })
            .catch((error) => {
                setShowToast(true);
                setToastMessage("Error getting Total Widget Count.");
                setToastVariant("danger");
                console.error("rror getting Total Widget Count.", error);
            });
    }, [])

    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
    const handleOpenRequestsClick = () => {
        setSelectedDateRange([null, null]);
        setSelectedStatuses([1]); // Set the filter to "Open"
    };



    const handleAppointmentsClick = () => { 
        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        setSelectedStatuses([]);
        setSelectedDateRange([formattedToday, formattedToday]); // Set start and end to today's date
    };
    return (
        
    <Fragment>
    {/* collapsed-body */}
    {/* <div className={`el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`}> */}
            {/* <DashboardHeader/> */}
        <div className="el-middle-wrapper">
            <div className="el-middle-section"> 
                <div className="el-middle-top">
                <DashboardCards src={DonationLogo} label="Open Requests" count={openRequests}  onClick={handleOpenRequestsClick}/>
                <DashboardCards src={TodaysDonationLogo} label="Today's Collections" count={appointments}  onClick={handleAppointmentsClick}/>
                {/* <DashboardCards src={WeekReportLogo} label="Report" count={8}/> */}
              
                    {/* <div className="el-middle-top-col">
                        <div className="el-middle-top-img"><img src={DonationLogo} alt="Upcoming Donation"/></div>
                        <div className="el-middle-top-content">
                            <strong>10</strong>
                            <span>Upcoming Donation</span>
                        </div>
                    </div> 
                    <div className="el-middle-top-col">
                        <div className="el-middle-top-img"><img src={TodaysDonationLogo} alt="Today's Donation"/></div>
                        <div className="el-middle-top-content">
                            <strong>8</strong>
                            <span>Today's Donation</span>
                        </div>
                    </div>
                    <div className="el-middle-top-col">
                        <div className="el-middle-top-img"><img src={WeekReportLogo} alt="8 week"/></div>
                        <div className="el-middle-top-content">
                            <strong>8 week</strong>
                            <span>Report</span>
                        </div>
                    </div>*/}
                </div>
                {/* requestor */}
                <SampleRequests selectedRange={selectedRange} setSelectedRange={setSelectedRange} openRequestsFilter={selectedStatuses} appointmentsFilter={selectedDateRange}  setOpenRequestsFilter={setSelectedStatuses} setAppointmentsFilter={setSelectedDateRange}  type="requestor"  ></SampleRequests>
            </div>
        </div>
    {/* </div> */}
    <Toaster
            show={showToast}
            message={toastMessage}
            variant={toastVariant}
            onClose={() => setShowToast(false)}
        />
</Fragment>
    );
}

export default RequestorHome;